// extracted by mini-css-extract-plugin
module.exports = {"markdown":"index_markdown__dv5W0"};